import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "页面未找到－翔田千里影视资料站",
    description: "你访问的页面不存在或已被移动，可返回首页，或前往影视作品与动态资讯列表继续浏览。",
    keywords: "翔田千里,页面未找到",
  });

  return (
    <SiteLayout>
      <div className="container-page flex min-h-[62vh] flex-col items-center justify-center py-16 text-center">
        <p className="font-heading text-6xl text-primary-200 md:text-8xl">404</p>
        <h1 className="mt-5 font-heading text-2xl text-foreground-950 md:text-3xl">这个场景不在剧本里</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面可能已被移动或删除。可以回到首页，也可以直接从作品库或资讯列表继续浏览。
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-home-4-line" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/works"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-film-line" aria-hidden="true"></i>
            影视作品
          </Link>
          <Link
            to="/search"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-search-line" aria-hidden="true"></i>
            全站搜索
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}